import { COLUMN_COLORS, COLUMN_INK, COLUMNS, columnFor } from "./logic";
import { registerCell } from "./cells";
import { useHallStore } from "./store";

export function BoardGrid() {
  const called = useHallStore((s) => s.called);
  const current = useHallStore((s) => s.current);
  const phase = useHallStore((s) => s.phase);
  const calledSet = new Set(called);
  const targeting = current != null && (phase === "calling" || phase === "seating") && !calledSet.has(current);

  return (
    <div className="v2-board mx-auto flex h-full min-h-0 w-full max-w-[1100px] flex-col overflow-hidden">
      <div className="grid min-h-0 min-w-0 flex-1 grid-cols-5 gap-0.5 md:gap-2">
        {COLUMNS.map((letter, col) => {
          const start = col * 15 + 1;
          return (
            <div key={letter} className="flex min-h-0 min-w-0 flex-col">
              <div className="v2-col-h text-center">{letter}</div>
              <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-px md:gap-1">
                {Array.from({ length: 15 }, (_, row) => {
                  const num = start + row;
                  const seated = calledSet.has(num);
                  const isTarget = targeting && num === current;
                  const colKey = columnFor(num);
                  return (
                    <div
                      key={num}
                      ref={(el) => registerCell(num, el)}
                      className={`v2-well ${seated ? "is-called" : ""} ${isTarget ? "is-target" : ""}`}
                      style={
                        seated
                          ? { backgroundColor: COLUMN_COLORS[colKey], color: COLUMN_INK[colKey] }
                          : undefined
                      }
                    >
                      {num}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
